import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"
import Helper from "composer/Helper.jsx"

import ElementFactory from "composer/views/stage/PlaybackElement/ElementFactory.jsx"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Icon,
  Tabs,
  Tab,
} from '@material-ui/core';

class EditElementDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      playbackData: null,
      activeTab: 0,
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({
      open: false,
    });
    this.state.open = false;
  }

  updateElementClicked() {
    if (this.refs.elementFactory.refs.elementForm.validateInput() == true) {
      this.refs.elementFactory.refs.elementForm.updatePlayback(this.state.playbackData['id']);
      this.handleClose();
    }
  }

  changeTab(index) {
    let newIndex = this.state.activeTab;
    newIndex = index;
    this.setState({ activeTab: newIndex });
    this.state.activeTab = newIndex;

    if (this.refs.elementFactory) {
      this.refs.elementFactory.setState({
        activeView: index,
      });
    }
  }

  handleTabChange = (event, index) => {
    this.changeTab(index);
  }

  render() {
    let elementType = 0;
    let playbackTime = 0;
    if (this.state.playbackData != null) {
      elementType = this.state.playbackData['kind'];
      playbackTime = this.state.playbackData['trigger_time'];
    }

    const steps = (Config.GET_PLAYBACK_CONFIG(elementType)['hasPosition']? [Localization.strings.POSITION, Localization.strings.CONTENT] : [Localization.strings.CONTENT]);

    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth={true}
          maxWidth={'md'}
        >
          <DialogTitle>
            <Icon className="buttonIconLeft" style={{fontSize: '36px', verticalAlign:'middle'}}>
              {elementType > 0?
              Config.GET_PLAYBACK_CONFIG(elementType)['icon'] : ""}
            </Icon>
            {
              Localization.strings.EDIT + " - " +
              (elementType > 0?
              Config.GET_PLAYBACK_CONFIG(elementType)['name']
              :
              "") + " at " +  Helper.fToHHMMSS(playbackTime)
            }
          </DialogTitle>
          <DialogContent>
            <Tabs
              value={this.state.activeTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              centered
              variant="fullWidth"
              style={{padding:'0 0 14px 0'}}
            >
              {steps.map((label, i) => {
                return (
                  <Tab key={i} label={label}/>
                );
              })}
            </Tabs>
            <ElementFactory parent={this} root={this.props.root} ref="elementFactory"
              playbackData={this.state.playbackData}
            />
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.handleClose}>
              {Localization.strings.CANCEL}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.updateElementClicked}
            >
              {Localization.strings.UPDATE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default EditElementDialog;
